import { FaSort, FaDownload } from 'react-icons/fa';
import React, { useEffect, useState } from 'react';
import { handleError } from '../utils/errorHandler';
import { colorsRangeHex, formatNumber,divipolas} from '../Transversal';
import { DEFAULT_FILTER, ArcFiltros } from './SesionDetalles';
import { API_URL, HEIGHT_BODY, WIDTH_RIGHT_PANEL, COLOR_FONT_TITLE,esCelular, topFooterOnExpanded, widthCelular  } from '../Config';
import RuralUrbano from '../graficos/RuralUrbano';
import Territorial from '../graficos/Territorial';
import { useAppState } from '../graficos/GraficoContext';
import { apiFetch } from '../apiClient';

let filterAnio = "";
let filterregrescarFiltros = 0;
let filterTipoClasificador = "";
let filterCodigoDivipolaPdetRegion = "";
let filterCodigoDivipolaPdetMunicipio = "";
let filterCodigoDivipolaDpto = "";
let filterCodigoDivipolaMpio = "";
let filterPeriodo = "";
let cargado = false;
let listaCantidades: number[] = [];
let currentOrder = "asc";
let consecutivoReact = 0;

class DivipolaCantidad {
    public codigoDivipola: string = "";
    public nombre: string = "";
    public cantidad: number = 0;
    public cantidadGlobal: number = 0;
    public cantidadInternos: number = 0; // nuevo: para mostrar cuando corresponde
}

interface BarraProps {
    filtrar: string;
    codigoDivipola: string;
    indicador: any,
    setCodigoDivipola: (codigo: string) => void;
}

const BarrasDetalles: React.FC<BarraProps> = ({ filtrar, codigoDivipola, indicador, setCodigoDivipola }) => {
    const {tieneRuralUrbano } = useAppState();
    const [divipolaCantidad, setdivipolaCantidad] = useState<DivipolaCantidad[]>([]);
    const [cantidadNacional, setCantidadNacional] = useState<number>(0);
    const [selectedNombre, setSelectedNombre] = useState<string>('');

    const getCantidadEncabezado = (datos: DivipolaCantidad[]) => {
        let cantidad = Math.max(...datos.map(divipola => divipola.cantidadGlobal));
        if (filterCodigoDivipolaDpto !== "") {
            const cantidadDpto = datos.find(divipola => divipola.codigoDivipola === filterCodigoDivipolaDpto);
            if (cantidadDpto) {
                cantidad = cantidadDpto.cantidad;
            }
        }
        if (filterCodigoDivipolaMpio !== "") {
            const cantidadMpio = datos.find(divipola => divipola.codigoDivipola === filterCodigoDivipolaMpio);
            if (cantidadMpio) {
                cantidad = cantidadMpio.cantidad;
            }
        }
        return cantidad;
    }

    const fetchDatos = async () => {
        var url = "";
        try {
            const startTime = performance.now();
            filterCodigoDivipolaDpto = DEFAULT_FILTER.codigoDivipolaDpto;
            filterCodigoDivipolaMpio = DEFAULT_FILTER.codigoDivipolaMpio;
            filterCodigoDivipolaPdetRegion = DEFAULT_FILTER.codigoDivipolaPdetRegion;
            filterCodigoDivipolaPdetMunicipio = DEFAULT_FILTER.codigoDivipolaPdetMunicipio;
            const valorNacional = indicador.avancePeriodo;
            const queryString = Object.keys(DEFAULT_FILTER)
                .filter(key => DEFAULT_FILTER[key as keyof ArcFiltros] !== undefined)
                .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(DEFAULT_FILTER[key as keyof ArcFiltros] ?? '')}`)
                .join('&');
            url = `${API_URL}/ArcIndicador/GetDivipolaCantidades?${queryString}`
            const response = await apiFetch(url);
            const data = await response.json();
            divipolaCantidad.length = 0;
            divipolaCantidad.push(...data);
            divipolaCantidad.filter((divipola) => divipola.codigoDivipola != 'TOTAL' && divipola.codigoDivipola != 'DESAGREGACIÓN');
            divipolaCantidad.sort((a, b) => b.cantidad - a.cantidad);
            const cantidadNacionalNuevo = getCantidadEncabezado(divipolaCantidad);
            setCantidadNacional(cantidadNacionalNuevo);
            //etCantidadNacional(valorNacional);
            setdivipolaCantidad(divipolaCantidad);
            listaCantidades = divipolaCantidad.filter((divipola) => {
                if (filterCodigoDivipolaDpto !== "") {
                    return divipola.codigoDivipola.length === 5;
                }
                return true;
            }).filter((divipola) => divipola.codigoDivipola != 'TOTAL' && divipola.codigoDivipola != 'DESAGREGACIÓN').map((divipola) => divipola.cantidad);
            const endTime = performance.now();
            const duration = endTime - startTime;
            setNombreDivipola();
            cargado = true;
            console.log(`Barras Fetch duration: ${duration} ms`);
        } catch (error) {
            handleError(error);
        }
    };

    const clickOnDivipola = (codigoDivipola: string) => {
        const divipola = divipolaCantidad.find(divipola => Number(divipola.codigoDivipola) === Number(codigoDivipola));
        if (divipola) {
            DEFAULT_FILTER.regrescarFiltros = DEFAULT_FILTER.regrescarFiltros + 1;
            if (DEFAULT_FILTER.esPDET == "1") {
                if (DEFAULT_FILTER.codigoDivipolaPdetRegion == "") {
                    DEFAULT_FILTER.codigoDivipolaPdetRegion = divipola.codigoDivipola;
                }
                else {
                    if (DEFAULT_FILTER.codigoDivipolaDpto == "") {
                        DEFAULT_FILTER.codigoDivipolaDpto = divipola.codigoDivipola;
                    }
                    else {
                        //if (DEFAULT_FILTER.codigoDivipolaPdetMunicipio == "") {
                        DEFAULT_FILTER.codigoDivipolaMpio = divipola.codigoDivipola;
                        DEFAULT_FILTER.codigoDivipolaPdetMunicipio = divipola.codigoDivipola;
                        //}
                    }
                }
            }
            else {
                if (DEFAULT_FILTER.codigoDivipolaDpto == "") {
                    DEFAULT_FILTER.codigoDivipolaDpto = divipola.codigoDivipola;
                }
                else {
                    //if (DEFAULT_FILTER.codigoDivipolaMpio == "") {
                    DEFAULT_FILTER.codigoDivipolaMpio = divipola.codigoDivipola;

                    //}
                }
            }
            //getDatos();
            consecutivoReact++;
            DEFAULT_FILTER.regrescarFiltros = DEFAULT_FILTER.regrescarFiltros + 1;
            setCodigoDivipola(consecutivoReact.toString());
        }
    }

    let yPostScroll = 0;
    const updateRenderer = () => {
        const cantidadNacionalVer = getCantidadEncabezado(divipolaCantidad);
        setCantidadNacional(cantidadNacionalVer);
        const barrasDiv = document.getElementById('barrasDivDetalles');
        let index = 0;
        const mostrarCantidadInternos = DEFAULT_FILTER.internos == "1" && filterCodigoDivipolaDpto === ""; // solo cuando no hay Dpto seleccionado
        if (barrasDiv) {
            // innerHTML is only used with trusted/generated content, not user input (safe from XSS)
            barrasDiv.innerHTML = '';
            divipolaCantidad
                .filter((divipola) => divipola.codigoDivipola != 'TOTAL')
                .filter((divipola) => {
                    if (filterCodigoDivipolaDpto !== "") {
                        return divipola.codigoDivipola.length === 5;
                    }
                    return true;
                })
                .forEach((divipola) => {
                    index++;
                    const row = document.createElement('div');
                    row.style.display = 'flex';
                    row.style.alignItems = 'center';
                    row.style.marginBottom = '0px';
                    row.style.fontSize = '10px';
                    row.style.cursor = 'pointer'; // Add this line to change cursor to hand pointer
                    row.onclick = () => clickOnDivipola(divipola.codigoDivipola);

                    const nombredivipola = document.createElement('div');
                    nombredivipola.style.flex = '0 0 100px';
                    nombredivipola.style.height = '20px';
                    nombredivipola.style.overflow = 'hidden';
                    nombredivipola.style.whiteSpace = 'nowrap';
                    nombredivipola.style.textOverflow = 'ellipsis';
                    nombredivipola.style.textAlign = 'left';
                    nombredivipola.textContent = divipola.nombre;

                    if (divipola.codigoDivipola === filterCodigoDivipolaMpio) {
                        yPostScroll = index
                        nombredivipola.style.backgroundColor = 'yellow';
                        nombredivipola.style.fontWeight = 'bold';
                    }
                    var anchoBarra = "140px";
                    if (esCelular)
                    {
                        anchoBarra = "100px";
                    }
                    const barraContainer = document.createElement('div');
                    barraContainer.style.flex = '0 0 ' + anchoBarra;
                    barraContainer.style.height = '15px';
                    barraContainer.style.backgroundColor = '#e0e0e0';
                    barraContainer.style.margin = '0 10px';
                    barraContainer.style.position = 'relative';

                    const lineaNacional = document.createElement('div');
                    lineaNacional.style.position = 'absolute';
                    lineaNacional.style.left = `${(divipola.cantidad / cantidadNacionalVer) * 100}%`;
                    lineaNacional.style.width = '2px';
                    lineaNacional.style.height = '100%';
                    lineaNacional.style.backgroundColor = 'gray';

                    barraContainer.appendChild(lineaNacional);

                    const barra = document.createElement('div');
                    barra.style.height = '100%';
                    barra.style.width = anchoBarra;
                    barra.style.backgroundColor = colorsRangeHex(listaCantidades, divipola.cantidad, divipola.codigoDivipola);
                    barra.style.borderRadius = '5px';

                    const porcentaje = document.createElement('div');
                    porcentaje.style.flex = '0 0 70px';
                    porcentaje.style.textAlign = 'right';                    
                    porcentaje.textContent = `${formatNumber(mostrarCantidadInternos ? (divipola.cantidadInternos) : (divipola.cantidad))}`;

                    barraContainer.appendChild(barra);
                    row.appendChild(nombredivipola);
                    row.appendChild(barraContainer);
                    row.appendChild(porcentaje);
                    barrasDiv.appendChild(row);
                });
        }
        //after render, scroll to selected row
        if (barrasDiv) {
            barrasDiv.scrollTop = (yPostScroll - 1) * 20;
        }
    };

    const getDatos = async () => {
        console.log("Barras getDatos");
        console.log(DEFAULT_FILTER);


        if (DEFAULT_FILTER.anio != filterAnio
            || DEFAULT_FILTER.tipoClasificador != filterTipoClasificador
            || filterCodigoDivipolaPdetRegion != DEFAULT_FILTER.codigoDivipolaPdetRegion
            || filterCodigoDivipolaPdetMunicipio != DEFAULT_FILTER.codigoDivipolaPdetMunicipio
            || DEFAULT_FILTER.codigoDivipolaDpto != filterCodigoDivipolaDpto
            || DEFAULT_FILTER.codigoDivipolaMpio != filterCodigoDivipolaMpio    
            || DEFAULT_FILTER.periodo != DEFAULT_FILTER.originalPeriodo
        ) {
            filterAnio = DEFAULT_FILTER.anio;
            filterTipoClasificador = DEFAULT_FILTER.tipoClasificador;
            filterCodigoDivipolaPdetRegion = DEFAULT_FILTER.codigoDivipolaPdetRegion;
            filterCodigoDivipolaPdetMunicipio = DEFAULT_FILTER.codigoDivipolaPdetMunicipio;
            filterCodigoDivipolaDpto = DEFAULT_FILTER.codigoDivipolaDpto;
            filterCodigoDivipolaMpio = DEFAULT_FILTER.codigoDivipolaMpio;
            filterPeriodo = DEFAULT_FILTER.periodo;
            
            if (indicador != "") {
                fetchDatos().then(() => {
                    updateRenderer();
                });
            }
        }

        /*
        if (DEFAULT_FILTER.regrescarFiltros != filterregrescarFiltros) {
            filterregrescarFiltros = DEFAULT_FILTER.regrescarFiltros;
            filterCodigoDivipolaDpto = DEFAULT_FILTER.codigoDivipolaDpto;
            filterCodigoDivipolaMpio = DEFAULT_FILTER.codigoDivipolaMpio;
            filterCodigoDivipolaPdetRegion = DEFAULT_FILTER.codigoDivipolaPdetRegion;
            filterCodigoDivipolaPdetMunicipio = DEFAULT_FILTER.codigoDivipolaPdetMunicipio;
            console.log("Original internos:" + DEFAULT_FILTER.originalInternos + ". Internos:" + DEFAULT_FILTER.internos);            
            if (indicador != "") {
                fetchDatos().then(() => {
                    updateRenderer();
                });
            }
        }
        */
    }

    const changeOrder = () => {
        if (currentOrder === "asc") {
            currentOrder = "desc";
            divipolaCantidad.sort((a, b) => a.cantidad - b.cantidad);
        } else {
            currentOrder = "asc";
            divipolaCantidad.sort((a, b) => b.cantidad - a.cantidad);
        }
        updateRenderer();
    }

    const renderButtons = () => {
        return (
            <div style={{ height: 20, margin: '5px', display: 'flex', justifyContent: 'space-between' }}>
                <button style={{ border: 'none', background: 'none', cursor: 'pointer' }} onClick={() => {
                    changeOrder();
                }}>
                    <FaSort color={COLOR_FONT_TITLE} />
                </button>
                <div>
                    <span style={{ color: COLOR_FONT_TITLE, fontSize: '12px', fontWeight: "bold" }}>
                        {indicador?.esFichaDepartamental === false && filterCodigoDivipolaDpto === "" ? "Cantidad municipios con datos" : "Acciones territoriales monitoreadas"}
                    </span>
                </div>
                <button style={{ border: 'none', background: 'none', cursor: 'pointer' }} onClick={() => {
                    downloadExcel();
                }}>
                    <FaDownload color={COLOR_FONT_TITLE} />
                </button>
            </div>
        );
    };
    const downloadExcel = () => {
        const XLSX = require('xlsx');
        const filteredGrilla = divipolaCantidad.map(({ codigoDivipola, nombre, cantidad, cantidadGlobal }) => ({
            "Código Divipola": codigoDivipola,
            "Departamento/Municipio": nombre,
            "Cantidad": cantidad,
            "Cantidad Global": cantidadGlobal
        }));
        const worksheet = XLSX.utils.json_to_sheet(filteredGrilla);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'DivipolaCantidad');
        const filtrosSeleccionados = Object.keys(DEFAULT_FILTER)
            .filter(key => {
                const value = DEFAULT_FILTER[key as keyof ArcFiltros];
                return value !== "" && (typeof value !== 'number' || value > 0);
            })
            .map(key => `${key}-${DEFAULT_FILTER[key as keyof ArcFiltros]}`)
            .join('_');
        let nombreArchivo = `barras_${DEFAULT_FILTER.anio}_${filtrosSeleccionados}.xlsx`;
        if (nombreArchivo.length >= 200) {
            nombreArchivo = nombreArchivo.substring(0, 190) + '.xlsx';
        }
        XLSX.writeFile(workbook, nombreArchivo);
    };

    const setNombreDivipola = () => {
        let nombre = "Nacional";
        if (filterCodigoDivipolaDpto !== "") { 
            const divipola = divipolas.find(divipola => divipola.Tipo == "Departamento" && divipola.CodigoDivipola == filterCodigoDivipolaDpto);
            nombre = divipola ? divipola.Nombre : 'Nacional';
        }
        if (filterCodigoDivipolaPdetRegion !== "") { 
            const divipola = divipolas.find(divipola => divipola.Tipo == "PdetRegion" && divipola.CodigoDivipola == filterCodigoDivipolaPdetRegion);
            nombre = divipola ? divipola.Nombre : 'Pdet';
            if (filterCodigoDivipolaDpto !== "") { 
                const divipola = divipolas.find(divipola => divipola.Tipo == "Departamento" && divipola.CodigoDivipola == filterCodigoDivipolaDpto);
                nombre = divipola ? divipola.Nombre : 'Nacional';
            }
        }
        setSelectedNombre(nombre);
    }


    useEffect(() => {
        getDatos();
    }, [filtrar, codigoDivipola, indicador, tieneRuralUrbano, selectedNombre,divipolaCantidad]);

/*
    if (divipolaCantidad.length == 0 && cargado) {
        return (
            <div style={{ width: WIDTH_RIGHT_PANEL, backgroundColor: "#ffffff", borderLeft: "1px solid #d3d3d3" }}>
                <div style={{ height: HEIGHT_BODY, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    No hay indicadores con los criterios seleccionados
                </div>
            </div>
        );
    }
*/



    let alto = "470px";
    if (!tieneRuralUrbano) {
        alto = "665px";
    }

    /*
    <div style={{ color: "#36c", fontWeight: 'bold' }}>Acciones territoriales monitoreadas</div>                
    <b>{selectedNombre}</b> ({formatNumber(cantidadNacional)})
    <div style={{ marginBottom: '10px', textAlign: 'center', fontSize: '10px' }}>Corresponde al porcentaje de concentración de intervenciones territoriales de los indicadores con desagregaciones</div>    
    */
    return (
        <div style={{ width: WIDTH_RIGHT_PANEL, backgroundColor: "#ffffff", borderLeft: "1px solid #d3d3d3" }}>
            <div style={{ height: HEIGHT_BODY ,marginBottom: '10px', textAlign: 'center', fontSize: '12px' }}>                            
                <Territorial filtrar={filtrar} codigoDivipola={codigoDivipola} indicador={indicador} />            
                <div style={{ height: 30, }}>
                    {renderButtons()}
                </div>
                <div id="barrasDivDetalles" style={{ width: WIDTH_RIGHT_PANEL, height: alto, overflowY: 'scroll', padding: '0 5px' }}>
                    <br /><br />
                    Cargando...
                </div>
                <RuralUrbano filtrar={filtrar} codigoDivipola={codigoDivipola} indicador={indicador} />
            </div>
        </div>
    );
};


export default BarrasDetalles;